import { Link } from 'react-router-dom';
import { videoArticles } from '@/mocks/articles';

export default function VideoSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-black font-heading text-foreground-950 text-center mb-10">
          爆料视频专区
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {videoArticles.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.slug}`}
              className="bg-background-100 rounded-xl overflow-hidden hover:bg-background-200 transition-colors duration-200 group cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={video.imageUrl}
                  alt={video.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2 py-0.5 text-xs font-semibold rounded-full bg-foreground-900/80 text-background-50 whitespace-nowrap">
                  视频
                </span>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 text-xs font-medium rounded bg-black/70 text-white whitespace-nowrap">
                  {video.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold font-heading text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {video.title}
                </h3>
                <div className="flex items-center justify-between mt-2 text-xs text-foreground-500">
                  <span>{video.category}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-play-line"></i>
                    {video.views}次播放
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}